<div class="offer-item">
  <a class="offer-link" [href]="'../../../assets/offers/details/' + offerDetailDocument" target="_self">
    <img [src]="'../../assets/offers/preview/' + offerImg" alt="" />
    <div class="offer-item-box">
      <h5 translate>{{ brand }}</h5>
      <h6 translate>{{ detail }}</h6>
    </div>
  </a>
</div>
